export default "__VITE_ASSET__CpLaJ7H0__"